import { render } from "./StorefrontBanner.vue?vue&type=template&id=f39d1c56&scoped=true"
import script from "./StorefrontBanner.vue?vue&type=script&lang=js"
export * from "./StorefrontBanner.vue?vue&type=script&lang=js"

import "./StorefrontBanner.vue?vue&type=style&index=0&id=f39d1c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39d1c56"]])

export default __exports__